import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield, Clock, Lock, Zap } from 'lucide-react';
import { Button } from './Button';
export function Pricing() {
  const checkoutLink = 'https://checkout.infodigitalcore.shop/cart/49511664025839:1';
  const includes = ['Acceso a todos los módulos', 'Los 4 bonos incluidos', 'Sistema completo listo para usar', 'Acceso de por vida', 'Actualizaciones incluidas'];
  return <section id="comprar" className="py-12 md:py-24 bg-white relative overflow-hidden" data-id="element-222">
      {/* Korean flag inspired background accent */}
      <div className="absolute top-10 left-10 w-32 h-32 md:w-48 md:h-48 rounded-full bg-red-500/5 blur-3xl" data-id="element-223"></div>
      <div className="absolute bottom-10 right-10 w-32 h-32 md:w-48 md:h-48 rounded-full bg-blue-500/5 blur-3xl" data-id="element-224"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-225">
        <div className="text-center max-w-3xl mx-auto mb-6 md:mb-12" data-id="element-226">
          <div className="inline-flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 rounded-full bg-red-100 text-red-700 font-bold mb-3 md:mb-6 animate-pulse text-xs md:text-base" data-id="element-227">
            <Clock className="w-4 h-4 md:w-5 md:h-5" data-id="element-228" />
            <span data-id="element-229">Promoción por tiempo limitado</span>
          </div>
          <div className="text-xs md:text-sm font-bold text-accent-500 tracking-[0.3em] mb-2" data-id="element-230">
            🇰🇷 PROFE COREANO PRO
          </div>
          <h2 className="text-2xl md:text-5xl font-extrabold text-brand-950 mb-2 md:mb-4" data-id="element-231">
            Accedé al Sistema PRO
          </h2>
          <p className="text-sm md:text-xl text-brand-600 font-medium px-2" data-id="element-232">
            Cupos limitados. Una vez agotados, el precio vuelve al valor
            original.
          </p>
        </div>

        <div className="max-w-xl mx-auto mb-8 md:mb-16" data-id="element-233">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-brand-950 rounded-2xl md:rounded-3xl p-1 shadow-2xl relative" data-id="element-234">
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-accent-500 text-white px-4 md:px-6 py-1 md:py-1.5 rounded-full text-[10px] md:text-sm font-bold uppercase tracking-wider shadow-lg whitespace-nowrap" data-id="element-235">
              ⚡ Oferta de lanzamiento
            </div>

            {/* Korean stamp seal - rotating */}
            <motion.div animate={{
            rotate: 360
          }} transition={{
            duration: 25,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute -top-6 -right-6 md:-top-8 md:-right-8 w-20 h-20 md:w-28 md:h-28 z-20 pointer-events-none" data-id="element-236">
              <svg viewBox="0 0 100 100" className="w-full h-full" data-id="element-237">
                <defs data-id="element-238">
                  <path id="circle" d="M 50, 50 m -38, 0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0" data-id="element-239" />
                </defs>
                <text className="fill-accent-500 text-[12px] font-extrabold tracking-[0.3em]" data-id="element-240">
                  <textPath href="#circle" data-id="element-241">
                    공식 한국어 시스템 · OFFICIAL · 공식 한국어 시스템 ·
                  </textPath>
                </text>
              </svg>
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-242">
                <div className="bg-accent-500 text-white w-10 h-10 md:w-14 md:h-14 rounded-full flex items-center justify-center font-extrabold text-lg md:text-2xl border-4 border-white shadow-xl" data-id="element-243">
                  PRO
                </div>
              </div>
            </motion.div>

            <div className="bg-brand-900 rounded-[1rem] md:rounded-[1.4rem] p-5 md:p-10 text-center border border-brand-700 relative overflow-hidden" data-id="element-244">
              {/* Hangul background */}
              <div className="absolute -bottom-8 -left-4 text-brand-800/40 text-[120px] md:text-[180px] font-extrabold select-none pointer-events-none leading-none" data-id="element-245">
                한
              </div>
              <div className="absolute -top-8 -right-4 text-brand-800/40 text-[120px] md:text-[180px] font-extrabold select-none pointer-events-none leading-none" data-id="element-246">
                국
              </div>

              <div className="relative z-10" data-id="element-247">
                <h3 className="text-2xl md:text-4xl font-extrabold text-white mb-1 md:mb-2" data-id="element-248">
                  Plan PRO
                </h3>
                <p className="text-brand-300 mb-5 md:mb-8 font-medium text-sm md:text-base" data-id="element-249">
                  Sistema completo + todos los bonos
                </p>

                <div className="bg-brand-950/50 rounded-xl md:rounded-2xl p-4 md:p-6 mb-5 md:mb-8 border border-brand-800" data-id="element-250">
                  <div className="flex items-center justify-center gap-2 mb-2" data-id="element-251">
                    <span className="text-red-400 line-through text-lg md:text-2xl font-bold" data-id="element-252">
                      $49.990
                    </span>
                    <span className="bg-accent-500 text-white text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-253">
                      -60%
                    </span>
                  </div>
                  <div className="flex items-center justify-center gap-1 text-white" data-id="element-254">
                    <span className="text-2xl md:text-3xl font-bold" data-id="element-255">$</span>
                    <span className="text-5xl md:text-7xl font-extrabold tracking-tight" data-id="element-256">
                      19.990
                    </span>
                  </div>
                  <div className="text-brand-300 text-xs md:text-sm mt-1 md:mt-2 font-medium" data-id="element-257">
                    Pago único · Acceso de por vida
                  </div>
                </div>

                <div className="mb-5 md:mb-8 text-left" data-id="element-258">
                  <p className="font-bold text-white mb-3 md:mb-4 text-sm md:text-base flex items-center gap-2" data-id="element-259">
                    <span className="text-accent-400" data-id="element-260">✓</span>
                    Qué incluye:
                  </p>
                  <ul className="space-y-2 md:space-y-3" data-id="element-261">
                    {includes.map((item, i) => <li key={i} className="flex items-start gap-2 md:gap-3" data-id="element-262">
                        <div className="mt-0.5 md:mt-1 bg-accent-500/20 p-0.5 rounded-full shrink-0" data-id="element-263">
                          <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-accent-400" data-id="element-264" />
                        </div>
                        <span className="text-brand-100 font-medium text-sm md:text-base" data-id="element-265">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>

                <Button href={checkoutLink} size="lg" fullWidth className="text-base md:text-lg shadow-glow md:!py-5 md:!text-xl" data-id="element-266">
                  Quiero el Plan PRO
                </Button>

                <div className="flex items-center justify-center gap-1.5 text-brand-400 text-xs mt-3 md:mt-4" data-id="element-267">
                  <Zap className="w-3 h-3 text-accent-400" data-id="element-268" />
                  <span data-id="element-269">Acceso inmediato luego del pago</span>
                </div>

                <div className="mt-4 md:mt-6 pt-4 md:pt-6 border-t border-brand-800" data-id="element-270">
                  <p className="text-accent-400 font-extrabold text-base md:text-lg tracking-wide" data-id="element-271">
                    화이팅! 선생님
                  </p>
                  <p className="text-brand-400 text-xs md:text-sm mt-1" data-id="element-272">
                    ¡Vamos profe! Es tu momento.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Guarantee */}
        <div className="max-w-3xl mx-auto bg-brand-50 rounded-xl md:rounded-2xl p-4 md:p-8 border border-brand-200 flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-center md:text-left" data-id="element-273">
          <div className="bg-white p-3 md:p-4 rounded-full shadow-sm shrink-0" data-id="element-274">
            <Shield className="w-8 h-8 md:w-12 md:h-12 text-green-500" data-id="element-275" />
          </div>
          <div data-id="element-276">
            <h4 className="text-base md:text-xl font-bold text-brand-950 mb-1 md:mb-2" data-id="element-277">
              Garantía de Satisfacción · 보장
            </h4>
            <div className="flex flex-wrap justify-center md:justify-start gap-2 md:gap-4 text-xs md:text-base text-brand-700 font-medium" data-id="element-278">
              <span className="flex items-center gap-1.5" data-id="element-279">
                <Check className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-500" data-id="element-280" />{' '}
                Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-281">
                <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-500" data-id="element-282" />{' '}
                Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-283">
                <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 text-green-500" data-id="element-284" />{' '}
                Garantía 7 días
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}